import { Space } from 'antd'
import customDataTableStyle from 'assets/styles/customDataTableStyle'
import { setPaginationPerPage } from 'features/Report/reportSlice'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import ContentContainer from 'general/components/ContentContainer'
import CustomDataTable from 'general/components/CustomDataTable'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import Utils, { getYearsFromDates } from 'general/utils/Utils'
import useGetSerials from 'hooks/Queries/useGetSerials'
import { useAppDispatch, useAppSelector } from 'hooks/useRedux'
import _ from 'lodash'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { defaultValues, fullColumns } from './Columns'
import { useExportMutation } from './../queries'
export const FullColumnReport = (props) => {
  const {
    isFetching,
    filters,
    setFilters,
    data: usedInvoiceStatistic,
    debouncedSearch,
    search,
    setSearch,
  } = props
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [dateSerial, setDateSerial] = useState([])
  const { data: serials } = useGetSerials('ALL', undefined, dateSerial)
  const { accounts } = useAppSelector((state) => state?.userList?.users)
  const sysConfig = useAppSelector((s) => s.systemConfig.formatNumber)
  //   const dynamicColumns = useAppDnD(fullColumns())
  // MARK --- Functions ---

  const { mutate: handleExport, isPending } = useExportMutation(
    fullColumns({ sysConfig, accounts }),
  )

  useEffect(() => {
    setFilters({
      q: debouncedSearch,
      page: 1,
    })
  }, [debouncedSearch, setFilters])

  const onchangeDate = (name, value, dateRange) => {
    if (name) {
      setDateSerial(getYearsFromDates({ ...filters, [name]: value }))
    } else {
      setDateSerial(
        getYearsFromDates({
          ...filters,
          startDate: dateRange[0],
          endDate: dateRange[1],
        }),
      )
    }
  }

  useEffect(() => {
    setDateSerial(getYearsFromDates(filters))
  }, [])

  return (
    <>
      <ContentContainer.Header
        titleContent={t('Báo cáo hàng ngày BV Phụ Sản TW')}
        description={`${t('Tổng')}: ${Utils.formatNumber(
          usedInvoiceStatistic?.total,
        )} ${t('Hóa đơn')} Tổng tiền: ${Utils.formatNumber(usedInvoiceStatistic.totalAmount)}`}
        toolBar={
          <Space>
            <CustomAntButton
              text={t('ExportExcel')}
              iconCn={Utils.cn(
                'fa-solid mr-2 p-0',
                isPending ? 'fa-spinner-third fa-spin' : 'fa-down-to-line',
              )}
              antProps={{
                disabled: isPending,
                className: 'btn btn-success',
                onClick: () =>
                  handleExport(
                    _.omit({ ...filters, classify: 'ALL' }, ['page', 'limit']),
                  ),
              }}
            />

            {/* <AppDnD
              defaultColumns={dynamicColumns}
              localStorageName={PreferenceKeys.savedFullColumnsBVPSInvoices}
            /> */}
          </Space>
        }
      >
        <Space wrap>
          <CustomAntInput
            borderRadius="sm"
            type="search"
            inputProps={{
              value: search,
              onChange: (e) => setSearch(e.target.value),
            }}
          />
          <FilterPopover
            menuPosition="bottomRight"
            onApply={setFilters}
            defaultValues={defaultValues({ serials, accounts })}
            savedKey="gFiltersBVPSInvoices"
            onchangeDate={onchangeDate}
            timeRange="TODAY"
          />
        </Space>
      </ContentContainer.Header>
      <ContentContainer.Body>
        <CustomDataTable
          customTableStyle={customDataTableStyle}
          columns={fullColumns({ sysConfig, accounts })}
          dataSource={usedInvoiceStatistic?.rows}
          isLoading={isFetching}
          pagination={{
            currentPage: filters?.page,
            onChangePage: (page) => setFilters({ page }),
            onChangeRowsPerPage: (limit) => {
              dispatch(setPaginationPerPage(limit))
              setFilters({
                limit,
                page: 1,
              })
            },
            rowsPerPage: filters?.limit,
            total: usedInvoiceStatistic?.total,
          }}
        />
      </ContentContainer.Body>
    </>
  )
}
